import React from 'react';
import ServiceItem from '../service-item';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const servicesList = [
    {
        img: '/images/pic/krdv/krdvServiceItemImg1.png',
        icon: '/images/svg/krdv/krdvServiceItemIcon1.svg',
        title: 'Заявка на&nbsp;финансирование',
        text: 'Создали систему заявок на&nbsp;получение юридическими лицами финансирования от&nbsp;банков. С&nbsp;помощью этой функции резидент в&nbsp;ЛК может подобрать для себя оптимальный банк и&nbsp;отправить ему заявку на&nbsp;кредитование его идеи или&nbsp;бизнеса. Сотрудники банков также имеют учетные записи, где&nbsp;обрабатывают заявки на&nbsp;кредитование.',
        isReversed: false,
    },
    {
        img: '/images/pic/krdv/krdvServiceItemImg2.png',
        icon: '/images/svg/krdv/krdvServiceItemIcon2.svg',
        title: 'Консультационные услуги',
        text: 'Создали систему, которая дает возможность обратиться в&nbsp;КРДВ по&nbsp;любому вопросу в&nbsp;рамках категорий и&nbsp;получить официальный ответ. Система выделяет менеджера, который принимает жалобы на&nbsp;любую инфраструктуру-резидента КРДВ. Менеджер помогает урегулировать любую ситуацию, даже если никакие другие инстанции не&nbsp;помогли.',
        isReversed: true,
    },
    {
        img: '/images/pic/krdv/krdvServiceItemImg3.png',
        icon: '/images/svg/krdv/krdvServiceItemIcon3.svg',
        title: 'Заявка на&nbsp;ТУ',
        text: 'Мы реализовали возможность подать заявку на получение технических условий по 6-ти видам инфраструктуры. Все формы приведены в вид, который требуют инфстрастуктурные организации: КРДВ получает заявку, обрабатывает, передает ее в организацию, а в случае получения ТУ передает их резиденту. Сервис сделан так, чтобы резидент для решения данного вопроса потратил минимальное количество своего времени.',
        isReversed: false,
    },
    {
        img: '/images/pic/krdv/krdvServiceItemImg4.png',
        icon: '/images/svg/krdv/krdvServiceItemIcon4.svg',
        title: 'Интегратор мер поддержки инвесторов',
        text: 'Разработали большой каталог мер государственной поддержки, где через систему фильтров пользователь может выбрать меру поддержки и сразу же перейти к форме заполнения на сайте института поддержки. Сервис по&nbsp;функционалу напоминает booking.com, только с различными инфраструктурами.',
        isReversed: true,
    },
    {
        img: '/images/pic/krdv/krdvServiceItemImg5.png',
        icon: '/images/svg/krdv/krdvServiceItemIcon5.svg',
        title: 'Заявка на резидентство и получение бизнес-плана',
        text: 'Разработали сложную систему анкетирования для получения статуса резидента. Помимо этого, система позволяет создать свой бизнес-план в&nbsp;автоматическом режиме&nbsp;&mdash; запрашивает часть данных, остальное считает и&nbsp;формирует автоматически.',
        isReversed: false,
    },
    {
        img: '/images/pic/krdv/krdvServiceItemImg6.png',
        icon: '/images/svg/krdv/krdvServiceItemIcon6.svg',
        title: 'Заявка на&nbsp;поиск инвестора',
        text: 'Запустили сервис, который позволяет резидентам найти инвестора для своего проекта. Резидент заполняет информацию по&nbsp;своим проектам, а&nbsp;инвесторы оценивают его на&nbsp;перспективность вложения инвестиций и&nbsp;откликаются, если проект заинтересовал.',
        isReversed: true,
    },
    {
        img: '/images/pic/krdv/krdvServiceItemImg7.png',
        icon: '/images/svg/krdv/krdvServiceItemIcon7.svg',
        title: 'Торговая площадка',
        text: 'Сделали аналог площадки &laquo;Авито&raquo;, с&nbsp;поправкой на&nbsp;специфику. С&nbsp;ее&nbsp;помощью резиденты могут предлагать друг другу товары и&nbsp;услуги в&nbsp;больших объемах. Например, 1000 тонн дальневосточной икры или краба.',
        isReversed: false,
    },
];

const Services = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="krdv-services">
                {servicesList.map((item, index) => (
                    <div className="krdv-services__item" key={index}>
                        <ServiceItem serviceItem={item} />
                    </div>
                ))}
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Services;
